






import Vue from 'vue';

import OrganizationPacketCreator from '@/views/authenticated/OrganizationPacketCreator.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPacketCreator,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    peerGroupId: Number
  }
});
